import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { NewProjectComponent } from '../new-project/new-project.component';
import { SharedDataService } from '../../../services/shared-data.service';
import { MatTosterService } from '../../../services/mat-toster.service';
import { APIConfigMapping, DeleteComponent, HTTPAPIConfig, VlDataService, VlHttpService,APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS } from 'shared-library';
import { ApppermissionsPipe, AppStateService, } from 'usermgmt';
import { SharedService } from 'ngx-mobile-app';
import { Subject, takeUntil } from 'rxjs';
import { StreamBlobService } from 'shared-library';
@Component({
  selector: 'app-create-project',
  templateUrl: './create-project.component.html',
  styleUrls: ['./create-project.component.scss'],
  providers: [ApppermissionsPipe]
})
export class CreateProjectComponent implements OnInit,OnDestroy {
  @ViewChild('sidenav') sidenav!: MatSidenav;
  displayedContent: string = 'dashboard';
  panelOpenState = false;
  customerProjectListData: any = [];
  projectData: any = [];
  createdProjectId!:string;
  createdProjectNames: any[] = [];
  spinnerVisible:boolean=false;
  private destroy$ = new Subject<void>();
  appPermissions: any = APP_BUILDER_PERMISSIONS;
  permissionsActions: any = PERMISSIONS_ACTIONS;

  constructor(private router: Router,private route: ActivatedRoute, public dialog: MatDialog,
    private dataService: VlDataService,
    private httpService: VlHttpService,
    private sharedDataService: SharedDataService,
    private toasterSrv:MatTosterService,
    private appStateSrv: AppStateService,
    private SharedService: SharedService,
    private appPermissionsPipe: ApppermissionsPipe,
    private streamBlobService: StreamBlobService,
    ) {}

  toggleSidebar() {
    this.sidenav.toggle();
  }

  showContent() {
    this.sharedDataService.content$.pipe(takeUntil(this.destroy$)).subscribe(content => {
      this.displayedContent = content;
    // this.sidenav.toggle();
    })
  }
 
  ngOnInit(){
    this.revertSetDataInSharedSrv()
    this.showContent();
    this.getProjects();
  }
  
  getProjects() {
    this.spinnerVisible=true;
    const userMetaInfo = this.appStateSrv.getUserMetaInfo();
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PROJECTS']);
    apiConfig.postData = { id: userMetaInfo && userMetaInfo['customerId']? userMetaInfo['customerId']: "null" }
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next:async (data: any) => {
        this.customerProjectListData = [];
        this.createdProjectNames = [];
        if (data?.length) {
          const processedData = await Promise.all(data.map(async (x: any) => {
            x.logo = `data:image/png;base64,${x.logo}`;

            if (x.blob_name) {
              try {
                x.image = await this.streamBlobService.fetchImage(x.blob_name);
              } catch (e) {
                x.image = null; 
              }
            }else{
              x.image = x.image + '?cache=' + x?.last_modified_date;
            }

         return x;
      }));

      this.customerProjectListData = processedData.reverse(); // unshift = reverse insertion
      this.createdProjectNames = processedData.map(p => p.project_name);
      }
        this.spinnerVisible=false;
      },
      error: (err: any) => {
        if(err?.status == 403) {
          this.toasterSrv.showError('You do not have permission to access this resource.');
        }

        this.spinnerVisible=false;
      } 
    })
  }

  createProject(projectName:string,projectDescription:string,projectIcon:File) {
    this.spinnerVisible=true;
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_PROJECT']);
    const userMetaInfo = this.appStateSrv.getUserMetaInfo();
    localStorage.removeItem('projectId');
    apiConfig.postData = {
      customer_uuid: userMetaInfo && userMetaInfo['customerId']? userMetaInfo['customerId']: "null",
      project_name: projectName,
      project_description: projectDescription,
    }
    this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data: any) => {
        this.toasterSrv.showToastMessage("Sucessfully Created Project", "success");
        localStorage.setItem('projectId',data.project_id);
        this.createdProjectId = data.project_id;
        this.addProjectLogo(data.project_id,projectIcon);
      },
      error: (err: any) => {
        this.spinnerVisible=false;
        if(err?.status == 403) {
          this.toasterSrv.showError('You do not have permission to access this resource.');
        }else{
          this.toasterSrv.showToastMessage("Error While creating Project", "error");
        }
      }
    })
  }

  addProjectLogo(project_id: string, projectLogo: File) {

      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['UPLOAD_MEDIA_IMAGE']);
      apiConfig.postData = {
        project_id: project_id,
        resource: projectLogo,
        project_logo:true,
      };
      this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
        next: (data: any) => {
           this.getProjects();
        },
        error: (err: any) => {
          this.spinnerVisible = false;
          if(err?.status == 403) {
            this.toasterSrv.showError('You do not have permission to access this resource.');
          }
        }
      });

  }

 

  

  createProjectDialog() {
    const dialogRef = this.dialog.open(NewProjectComponent, {
      disableClose: true,
      data: {
        projectOperation: 'ADD',
        projectData: this.projectData,
        projectNames: this.createdProjectNames
      }
    });


    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (typeof (result) !== 'boolean' && result !== undefined && result !== '') {
        this.createProject(result.projectName,result.projectDescription,result.projectIcon);
      }
    });


  }

  
  onProjectCardClick(projectData: any, projectId: string,projectName:string) {
    if (this.appPermissionsPipe.transform([this.appPermissions.webApplication, this.permissionsActions.edit]) || this.appPermissionsPipe.transform([this.appPermissions.mobileApplication, this.permissionsActions.edit])) {
      localStorage.setItem('ProjectMetaData', JSON.stringify(projectData));
      localStorage.setItem('projectId',projectId);
      localStorage.setItem('projectName',projectName);
      const currentParams = { ...this.route.snapshot.queryParams };
      currentParams['id'] = projectId;
      currentParams["projectName"] = projectName;

      const homeBreadcrumbObj = { id: '', label: 'home', state: 'home'};
      const newBreadcrumbObj = { id: projectId, label: projectName, state: 'project' };
      const newBreadcrumb = [homeBreadcrumbObj,newBreadcrumbObj];
      this.SharedService.updateBreadcrumb(newBreadcrumb);

      this.router.navigate(['home','applications'], {
      queryParams: {
        "id":projectId,
        "projectName":projectName
      }
      });
      localStorage.setItem("projectId",projectId);
    } else {
      this.toasterSrv.showToastMessage("You don't have permission to access applications", "error");
    }
  }

  editProjectDialog(item: any){
    const dialogEditProjRef = this.dialog.open(NewProjectComponent, {
      disableClose: true,
      data: {
        projectOperation: 'EDIT',
        projectData: item,
        projectNames: this.createdProjectNames,       
      }
    });
    localStorage.setItem('projectId',item.project_id);
    dialogEditProjRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result) {
        this.getProjects();
      }
    })
  }

  deleteProject(projectId: string){
    const dialogRef = this.dialog.open(DeleteComponent, {
      width: '400px',
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if(result == true){
        this.spinnerVisible=true;
        const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_PROJECT']);
        apiConfig.postData = { id: projectId };
        this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
          next: (data: any) => {
            this.toasterSrv.showToastMessage("Sucessfully Deleted Project", "success");
            this.getProjects();
          },
          error: (err: any) => {
            this.spinnerVisible=false;
            if(err?.status == 403) {
              this.toasterSrv.showError('You do not have permission to access this resource.');
            }else{
              this.toasterSrv.showToastMessage("Error While Deleted Project", "error");
            }
          } 
        })
      }
    }) 
  }

  // last modified Date format setter
  formatLastModified(lastModified: string): string {
    const modifiedDate = new Date(lastModified);
    const currentDate = new Date();
    const timeDifference = currentDate.getTime() - modifiedDate.getTime();
    const minutesDifference = Math.floor(timeDifference / (1000 * 60));
    const hoursDifference = Math.floor(minutesDifference / 60);
    const daysDifference = Math.floor(hoursDifference / 24);
    
    if (daysDifference > 0) {
      if (daysDifference === 1) {
        return '1 day ago';
      } else {
        return `${daysDifference} days ago`;
      }
    } else if (hoursDifference > 0) {
      if (hoursDifference === 1) {
        return '1 hour ago';
      } else {
        return `${hoursDifference} hours ago`;
      }
    } else if (minutesDifference > 0) {
      if (minutesDifference === 1) {
        return '1 minute ago';
      } else {
        return `${minutesDifference} minutes ago`;
      }
    } else {
      return 'Just now';
    }
  }
  revertSetDataInSharedSrv(){
    this.SharedService.setThemeData(null);
    this.SharedService.setApplicationDataEntire(null);
    this.SharedService.setApplicationData(null);
    this.SharedService.setApplicationDataById(null)
  }

  copyApplication(projectId: string) {
     const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['COPY_PROJECT']);
      apiConfig.postData = { project_id: projectId };
      this.spinnerVisible=true;
        this.httpService.placeAPICall(apiConfig).pipe(takeUntil(this.destroy$)).subscribe({
          next: (data: any) => {
            this.toasterSrv.showToastMessage(" copy project started", "success");
            this.spinnerVisible=false;
          },
          error: (err: any) => {
            
            this.spinnerVisible=false;
            if(err?.status == 403) {
              this.toasterSrv.showError('You do not have permission to access this resource.');
            }else{
              this.toasterSrv.showToastMessage("Error While copying  Project", "error");
            }
          } 
        })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
